module.exports = "<div class=modal-header><h4 class=modal-title>Changing your department will clear the items in your basket</h4></div><div class=modal-footer><button class=\"btn btn-kt\" ng-click=changeDepartmentOk()>Continue</button> <button class=\"btn btn-warning\" ng-click=changeDepartmentCancel()>Cancel</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/main/templates/modals/departmentConfirm.tmpl.html
// module id = 3310
// module chunks = 0